import { render, staticRenderFns } from "./type-image.vue?vue&type=template&id=42a046fc&scoped=true&"
import script from "./type-image.vue?vue&type=script&lang=js&"
export * from "./type-image.vue?vue&type=script&lang=js&"
import style0 from "./type-image.vue?vue&type=style&index=0&id=42a046fc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a046fc",
  null
  
)

export default component.exports